<template>
    <div class="micro-headerwidgets-projects" :data-plugin-name="VUE_APP_NAME" :id="VUE_APP_NAME">
        <Products :service="service" :key="service.refreshKey"/>
    </div>
</template>
<script>
import './App.reset.scss';
import { VUE_APP_NAME } from './config/config';
import Products from './components/Products';

export default {
    name: 'App',
    components: {
        Products,
    },
    props: {
        service: {
            type: Object,
            required: true,
        },
    },
    data() {
        this.VUE_APP_NAME = VUE_APP_NAME;
        return {};
    },
    methods: {

    },
};
</script>

<style lang="scss">
.micro-headerwidgets-projects{
    margin: 0;
}
</style>
